import { render, staticRenderFns } from "./ShippingPackageModal.vue?vue&type=template&id=80a4fc46&scoped=true"
import script from "./ShippingPackageModal.vue?vue&type=script&lang=js"
export * from "./ShippingPackageModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingPackageModal.vue?vue&type=style&index=0&id=80a4fc46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a4fc46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
